import { useEffect } from "react";
import { matchPath, useLocation, useMatch } from "react-router-dom";
import { IRoutes } from "../App";

export const useScrollHandler = (definedRoutes: IRoutes) => {
  const location = useLocation();

  useEffect(() => {
    const routesValues = Object.values(definedRoutes);
    const isDefinedRoute = routesValues.some(
      (route) => matchPath({ path: route }, location.pathname) !== null
    );
    console.log("location.pathname", location.pathname);
    if (
      !isDefinedRoute ||
      location.pathname === "/not-found" ||
      location.pathname.includes("confirm-account")
    ) {
      document.body.classList.add("notFoundPageBody");
    } else {
      document.body.classList.remove("notFoundPageBody");
    }
  }, [location, definedRoutes]);
};
